OE.addPlugin('Mailchimp', (function(){

    var Plugin = {},
        Options = {
        },
        querySelector = '.mc4wp-form';

    Plugin.init = function()
    {
        addOnSubmitEvent();
    };

    var addOnSubmitEvent = function(body)
    {
        var forms = getMailchimpForms(body),
            form_count = forms.length;

        for(var i = 0; i < form_count; i++ )
        {
            var form = forms[i];
            if(!form.hasSubmitEvent)
            {
                form.hasSubmitEvent = true;
                form.addEventListener('submit', onSubmit.bind(form) );
            }
        }
    };

    var getMailchimpForms = function(body)
    {
        if(typeof body === 'undefined')
        {
            body = OE.$doc.querySelector('body');
        }

        if(OE.Utils.matches(body, 'form') )
        {
            return [body];
        }

        return body.querySelectorAll('form' + querySelector + ', ' + querySelector + ' form');
    };

    var getContainerOfForm = function(element)
    {
        while(element && !OE.Utils.matches(element, querySelector) )
        {
            element = element.parentElement;
        }

        return element;
    };

    var onSubmit = function(e)
    {
        try { e.preventDefault(); } catch(ev) { }

        var form = this,
            url = form.getAttribute('action') || OE.$win.location.href,
            type = form.getAttribute('method') || 'post',
            data = serialize(form);

        OE.Plugins.Ajax.request(url, {
            post : type === 'post',
            data : data,
            onStart : onStart.bind(form),
            onStop : onStop.bind(form),
            onSuccess : onSuccess.bind(form),
            headers : {
//                'Content-type' : 'text/plain; charset=x-user-defined'
                'Content-type' : 'application/x-www-form-urlencoded'
//                'Content-Type' : 'application/json; charset=UTF-8'
            }
        });

        return false;
    };

    var onStart = function(request)
    {
        var form = this;
        form.classList.add('is--submitting');
    };

    var onStop = function(request)
    {
        var form = this;
        form.classList.remove('is--submitting');
    };

    var onSuccess = function(request)
    {
        var form = this,
            form_id = form.getAttribute('id'),
            html = request.responseText,
            id, parser, xmlDoc, destination_postlist;

        if(form_id)
        {
            parser = new DOMParser();
            xmlDoc = parser.parseFromString(html, "text/html");
            destination_form = xmlDoc.getElementById(form_id);
            if(destination_form)
            {
                form.outerHTML = destination_form.outerHTML;
                addOnSubmitEvent(form);
                trigger_ga();
            }
            else
            {
                form.classList.add('has--loading-error');
            }
        }
    };

    var trigger_ga = function()
    {
        if(typeof OE.Plugins.GA)
        {
            OE.Plugins.GA.trackEvent("Newsletter", "signup", "Newsletter page");
        }
    };

    var serialize = function(form)
    {
        var field, s = [];

        if (typeof form === 'object' && form.nodeName === "FORM") {
            var len = form.elements.length;
            for (i=0; i<len; i++) {
                field = form.elements[i];
                if (field.name && !field.disabled && field.type !== 'file' && field.type !== 'reset' && field.type !== 'submit' && field.type !== 'button') {
                    if (field.type === 'select-multiple') {
                        for (j=form.elements[i].options.length-1; j>=0; j--) {
                            if(field.options[j].selected)
                            {
                                s[s.length] = encodeURIComponent(field.name) + "=" + encodeURIComponent(field.options[j].value);
                            }
                        }
                    } else if ((field.type !== 'checkbox' && field.type !== 'radio') || field.checked) {
                        s[s.length] = encodeURIComponent(field.name) + "=" + encodeURIComponent(field.value);
                    }
                }
            }
        }
        return s.join('&').replace(/%20/g, '+');
    };

    return Plugin;
})());
